export const fr = {
  // topnav
  Search: 'Rechercher',
  FullScreen: 'Plein écran',
  Refresh: 'Rafraichir',
  selected: 'sélectionné',

  LogIn: 'S\'identifier',
  LogOut: 'Se déconnecter',
  SignUp: 'S\'enregistrer',
  SignIn: 'Se connecter',

  // sidenav
  Alerts: 'Alertes',
  Heartbeats: 'Signaux de présence',
  Users: 'Utilisateurs',
  Groups: 'Groupes',
  Customers: 'Clients',
  Blackouts: 'Gestion des temps d\'arrêts',
  Permissions: 'Permissions',
  APIKeys: 'Clés API',
  Searches: 'Searches',
  Labels: 'Labels',
  Reports: 'Rapports',
  More: 'Plus',
  Settings: 'Paramètres',
  Help: 'Aide',
  About: 'A propos',

  // more
  ChooseDisplayDensity: 'Choisir le format d\'affichage',
  DisplayDensity: 'Format d\'affichage',
  Comfortable: 'Confortable',
  Compact: 'Compact',
  Panel: 'Panneau',
  Hide: 'Cacher',
  Show: 'Voir',
  DownloadAsCsv: 'Télécharger comme csv',

  // Groups store
  UserAddedGroup: 'Utilisateur ajouté au groupe.',
  UserRemovedGroup: 'Utilisateur supprimé du groupe.',

  // Preferences store
  SettingsSaved: 'Paramétrage sauvegardé.',
  SettingsReset: 'Paramètres réinitialisés aux valeurs par défaut.',
  SettingsError: 'Impossible de récupérer les préférences de l\'utilisateur.',

  // Users store
  UserStatusSaved: 'Statut utilisateur enregistré.',
  EmailSaved: 'Email vérifié enregistré.',

  // statuses
  Open: 'Open',
  Assign: 'Assign',
  Ack: 'Ack',
  Shelved: 'Shelved',
  Blackout: 'Blackout',
  Closed: 'Closed',
  Expired: 'Expired',
  Unknown: 'Unknown',
  NotValid: 'Not Valid',

  // operator actions
  Open: 'Open', //'Ouvrir'
  Assign: 'Assign',
  Ack: 'Ack', //'Affecter',
  Unack: 'Unack', //'remis à disposition',
  Shelve: 'Shelve', //'mis en attente',
  Unshelve: 'Unshelve',
  Close: 'Close', //'Fermé',
  Watch: 'Watch', //'Surveiller',
  Unwatch: 'Unwatch', //'Ne plus surveiller',
  AddNote: 'Add note', //'Ajouter Note',
  Delete: 'Delete', //'Supprimer',

  // Alert actions
  TextIsRequired: 'Text is required',
  TextMustBeLessThan: 'Text must be less than',
  characters: 'characters',

  // Alert detail
  AlertId: 'Id alerte',
  AlertOrNoteId: 'Id alerte ou note',
  LastReceiveAlertId: 'Dernier Id reçu',
  CreateTime: 'Date de création',
  ReceiveTime: 'Date de réception',
  LastReceiveTime: 'Dernière réception',
  Customer: 'Client',
  Service: 'Service',
  Environment: 'Environnement',
  Resource: 'Ressource',
  Event: 'Evénement',
  Correlate: 'Corrélation',
  Group: 'Groupe',
  Severity: 'Gravité',
  Status: 'Statut',
  Value: 'Valeur',
  Text: 'Texte',
  TrendIndication: 'Indicateur Trend',
  Timeout: 'Délai',
  Type: 'Type',
  DuplicateCount: 'Doublons',
  Repeat: 'Répéter',
  Origin: 'Origine',
  Tags: 'Tags',
  Attributes: 'attributs',
  History: 'Historique',
  Data: 'Donnée',

  Details: 'Détail',
  addedNoteOn: 'a ajouté une note le',
  by: 'par',

  // Alert history
  UpdateTime: 'Date de mise à jour',
  Updated: 'Mis à jour',
  User: 'Utilisateur',

  // Alert list
  Loading: 'Chargement en cours',
  NoDataAvailable: 'Pas de données disponibles',
  ALL: 'Toutes les alertes',
  Description: 'Description',
  Attribute: 'Attribut',
  TimeoutLeft: 'Délai restant',
  Dupl: 'Doublons',
  PrevSeverity: 'Gravité Prec.',
  Duration: 'Durée',
  LastReceiveId: 'Dernier Id reçu',
  LastNote: 'Dernière Note',

  // Alert list filter
  Filters: 'Filtres',
  FilterDescription: 'Filtrer les résultats par recherche de texte',
  AllEnvironments: 'Tous les environnement',
  EnvironmentDescription: 'Choisissez un ou plusieurs environnement',
  AllSeverities: 'Tous les gravité',
  SeverityDescription: 'Choisissez un ou plusieurs gravité',
  AllStatuses: 'Tous les statuts',
  StatusDescription: 'Choisissez un ou plusieurs statuts',
  AllCustomers: 'Tous les clients',
  CustomerDescription: 'Choisissez un ou plusieurs clients',
  AllServices: 'Tous les services',
  ServiceDescription: 'Choisissez un ou plusieurs services',
  AllGroups: 'Tous les groupes',
  GroupDescription: 'Choisissez un ou plusieurs groupes',

  Latest: 'Les + récentes',
  Hour: '1 heure',
  SixHours: '6 heures',
  TwelveHours: '12 heures',
  SelectRange: 'Sélectionner une periode',

  DateTime: 'Date/Temps',
  StartDate: 'Date de début',
  EndDate: 'Date de fin',
  Time: 'Temps',
  Apply: 'Appliquer',
  Reset: 'Vider les champs',

  // API keys
  APIKey: 'Clé API',
  Search: 'Rechercher',
  Customer: 'Client',
  Scopes: 'Périmètres',
  Expires: 'Expire',
  Active: 'Actif',
  Expired: 'Expiré',
  Slow: 'Lent',

  User: 'Utilisateur',
  LastUsed: 'Dernière utilisation',
  Actions: 'Actions',

  Copy: 'Copier',
  Copied: 'Copié!',
  NewApiKey: 'Nouvelle Clé API',
  EditApiKey: 'Modifier Clé API',

  // Blackouts
  ChooseService: 'Choisir un ou plusieurs service',
  Start: 'Début',
  End: 'Fin',
  Created: 'Date de création',
  Reason: 'Raison',
  NewBlackout: 'Nouvel incident',
  EditBlackout: 'Modifier incident',
  Active: 'Actif',
  Pending: 'En Attente',
  Expired: 'Expiré',

  // Customers
  LookUp: 'Chercher',
  LookUpDescription: 'Utiliser l\'identifiant, le rôle Keycloak, l\'organisation GitHub, le groupe GitLab ou le domaine de messagerie',
  NewCustomer: 'Nouveau client',
  EditCustomer: 'Modifier client',

  // Groups
  AddRemoveUsers: 'Ajouter/Modifier utilisateurs',
  Addusers: 'Ajouter utilisateurs',
  UsersInGroup: 'Utilisateurs du groupe',
  NumberUsers: 'Nombre d\'utilisateurs',
  NewGroup: 'Nouveau groupe',
  EditGroup: 'Modifier groupe',

  // Heartbeats
  Latency: 'Latence',
  Since: 'Depuis',

  // Manifest
  API: 'API',
  OpenGitHub: 'Ouvrir dans GitHub',
  WebUI: 'Web UI',
  Build: 'Build',
  Date: 'Date',
  GitRevision: 'Git Revision',
  APIEndpoint: 'API Endpoint',

  // Perms
  Role: 'Rôle',
  Scope: 'Périmètre',
  SystemRole: 'Rôle Système',
  NewPermission: 'Nouvelle permission',
  EditPermission: 'Modifier permission',

  // Preferences
  ApplicationSettings: 'Paramètres d\'application',
  DarkTheme: 'Thème sombre',
  PlaySounds: 'Son notifications',
  LanguageSettings: 'Paramétrage de la langue',
  Languages: 'Langues',
  English: 'Anglais',
  French: 'Français',
  German: 'Allemand',
  DateTimeSettings: 'Paramétrage date et heure',
  LongDate: 'Format de date longue',
  MediumDate: 'Format de date moyenne',
  ShortTime: 'Format de temps courte',
  DisplayMode: 'Mode d\'affichage',
  UseLocal: 'Date et heure locale',
  UseUTC: 'Utiliser le temps universel (UTC)',
  AlertSettings: 'Paramétrage des alertes',
  ShowAllowedEnvs: 'Toujours afficher les environnements autorisés',
  ShowNotesIcon: 'Afficher l\'icône des notes',
  ShowNotesHint: 'Afficher l\'icône à côté de l\'état de l\'alerte pour indiquer une note d\'opérateur',
  Font: 'Texte',
  FontSize: 'Taille de la police',
  FontWeight: 'Niveaux de graisse',
  PageRows: 'Lignes par page',
  rows: 'lignes',
  ValueWidth: 'Value Width',
  DescriptionWidth: 'Description Text Width',
  RefreshInterval: 'Intervalle de rafraîchissement',
  seconds: 'secondes',
  minutes: 'minutes',
  AckTimeout: 'Durée de mise en affecter',
  ShelveTimeout: 'Durée de mise en attente',
  hours: 'heures',

  // Profile
  Profile: 'Profil',
  UserID: 'User ID',
  PrimaryUserID: 'Principal User ID',
  Provider: 'Provider',
  EmailVerified: 'Email verifié',
  EmailNotVerified: 'Email non verifié',
  Customers: 'Clients',
  Organizations: 'Organisations',
  Groups: 'Groupes',
  Roles: 'Rôles',
  Scopes: 'Périmètres',
  others: 'autres',

  // Status
  LastUpdate: 'Dernière mise à jour',
  Uptime: 'Disponibilité',
  Metric: 'Métrique',
  Type: 'Type',
  Name: 'Nom',
  Value: 'Valeur',
  AvgTime: 'Temps Moyen',
  
  // Users
  Active: 'Actif',
  Inactive: 'Inactif',
  Login: 'Identifiant',
  Email: 'Email',
  Verified: 'Vérifié',
  Comment: 'Commentaire',
  VerifiedOrNot: 'Vérifié ?',
  LastLogin: 'Dernière connexion',
  NewUser: 'Nouvel utilisateur',
  EditUser: 'Modifier utilisateur',
  
  // Reports
  Top: 'Top',
  Flapping: 'des signaux de présence',
  Offenders: 'du nombres d\'alerte',
  Standing: 'des alertes constantes',
  TopFlappingDescription: 'Sources d\'alerte ayant généré le plus grand nombre de changements de gravité d\'alerte.',
  TopOffendersDescription: 'Sources d’alerte fréquentes ayant généré le plus grand nombre d’alertes et de doublons d’alerte.',
  TopStandingDescription: 'Sources d\'alertes obsolètes ayant des alertes actives pendant une durée prolongée.',
  
  Count: 'Compteur',
  DuplCount: 'Doublons',
  Services: 'Services',
  Resources: 'Ressources',

  // User Confirm
  Thanks: 'Merci !',
  YouCanNowLogin1: 'Vous pouvez maintenant',
  YouCanNowLogin2: 'login.',
  EmailConfirmFailed: 'Désolé, un problème est survenu lors de la confirmation de votre email.',
  TryAgain: 'Veuillez réessayer',

  // User Forgot
  ResetLink: 'Entrez votre email et nous vous enverrons un lien de réinitialisation',
  AlreadyHaveAccount: 'Vous avez déjà un compte?',
  CheckEmail: 'Vérifiez votre email pour un lien de réinitialisation...',
  ReturnSignIn: 'Retour à la connexion',
  ResetEmailSent: 'Réinitialiser l\'email envoyé avec succès!',
 
  // User Login
  LoginToContinue: 'Se connecter à Alerta pour continuer',
  Username: 'Identifiant',
  Password: 'Mot de passe',
  CreateAccount: 'Créer un compte',
  ForgotPassword: 'Mot de passe oublié?',
  UnspecifiedProblem: 'Désolé, il y a eu un problème',
  AuthWith: 'Authentification avec',
  AuthInProgress: 'Authentification en cours...',
  AuthNotPossible: 'Désolé, il n\'est pas possible de vous authentifier',
  AuthProviderUnknown: 'Fournisseur d\'authentification inconnu',

  // User Logout
  LoggedOut: 'Vous avez été déconnecté.',

  // User Reset
  ChooseNewPassword: 'Choisissez un nouveau mot de passe',
  ConfirmPassword: 'Confirmer mot de passe',
  ResetPassword: 'Réinitialiser le mot de passe',

  // User Signup
  CreateAlertaAccount: 'Créez votre compte Alerta',
  SignUpNotAvailable: 'Désolé, l\'inscription n\'est pas disponible actuellement',
  FullName: 'Nom complet',
  Min6Char: '6 caractère minimum',
  PasswordNotMatch: 'Le mot de passe entré ne correspond pas',

  // Labels
  scope: 'périmètre',
  role: 'rôle',
  customer: 'client',
  group: 'groupe',

  // General
  ConfirmDelete: 'Êtes-vous sûr de bien vouloir supprimer cet élément?',
  Error: 'Erreur',
  Send: 'Envoyer',
  Required: 'Requis',
  Cancel: 'Annuler',
  Save: 'Sauvegarder',
  NoDisplay: 'Désolé, rien à afficher ici :(',
  SearchNoResult1: 'Votre recherche pour ',
  SearchNoResult2:  'n\'a trouvée aucun résultat.',
  OK: 'OK',

  // ENDS.
}
